import { render, staticRenderFns } from "./CartView.vue?vue&type=template&id=497b973e"
import script from "./CartView.vue?vue&type=script&lang=ts"
export * from "./CartView.vue?vue&type=script&lang=ts"
import style0 from "./CartView.vue?vue&type=style&index=0&id=497b973e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports